import { render, staticRenderFns } from "./vsTabs.vue?vue&type=template&id=228260f0&lang=html"
import script from "./vsTabs.vue?vue&type=script&lang=js"
export * from "./vsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports